module.exports = __webpack_public_path__ + "img/che1.png";